export type AtencionAlCiudadanoItem = {
	img: React.FC<React.SVGProps<SVGSVGElement>>;
	title: string;
	description: string;
};
import { ReactComponent as IconLegalizacion } from '@/assets/images/legalizacion-y-apostillas.svg';
import { ReactComponent as IconCopias } from '@/assets/images/solicitud-de-copias.svg';
import { ReactComponent as IconMatrimonial } from '@/assets/images/expediente-matrimonial.svg';
import { ReactComponent as IconGuardia } from '@/assets/images/notarios-de-guardia.svg';
import { ReactComponent as IconIdiomas } from '@/assets/images/notarios-que-hablan-tu-idioma.svg';
import { ReactComponent as IconTelefono } from '@/assets/images/atencion-telefonica.svg';

export const items: AtencionAlCiudadanoItem[] = [
	{
		img: IconLegalizacion,
		title: 'Legalización y apostillas',
		description: 'Cuando un documento notarial otorgado en España se va a usar en el extranjero',
	},
	{
		img: IconCopias,
		title: 'Solicitud de copias',
		description: 'Para poder solicitar copias, los solicitantes deben ser parte interesada de las mismas',
	},
	{
		img: IconMatrimonial,
		title: 'Expediente matrimonial',
		description: 'Si uno de los contrayentes vive en Madrid, puede tramitar su expediente matrimonial',
	},
	{
		img: IconGuardia,
		title: 'Notarios de guardia',
		description: 'Las notarías de guardia atenderán, siempre con cita previa, las urgencias inesperadas.',
	},
	{
		img: IconIdiomas,
		title: 'Notarios que hablan tu idioma',
		description: 'En el directorio de los notarios europeos puede buscar uno que hable tu idioma.',
	},
	{
		img: IconTelefono,
		title: 'Atención telefónica',
		description: '91 213 00 00',
	},
];
